export default __webpack_public_path__ + "static/media/logoV2.8ad9bd0d.png";